import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { CheckCircle, ArrowRight } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
const SponsorSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [state, setState] = useState({ status: 'checking', payment_status: 'pending', ad: null });
  const attempts = useRef(0);
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      if (attempts.current >= 60) { setState((s) => ({ ...s, status: 'timeout' })); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/sponsor/status/${sessionId}`);
        if (cancelled) return;
        setState(data);
        if (data.payment_status === 'paid' && data.ad) return;
        if (data.status === 'expired') return;
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const live = state.payment_status === 'paid' && state.ad;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-16 text-center">
      {!live ? (
        <>
          <div className="h-24 w-24 mx-auto rounded-full bg-gradient-to-br from-bx-cyan via-bx-magenta to-bx-volt breathe" />
          <h1 className="font-display text-3xl sm:text-5xl font-black tracking-tighter mt-6">
            Composing your <span className="shimmer-text">spot…</span>
          </h1>
          <p className="text-white/60 mt-2 text-sm">Generating the AI banner. Hold tight.</p>
        </>
      ) : (
        <div className="pop-in">
          <CheckCircle size={48} weight="fill" className="text-bx-volt mx-auto" />
          <h1 className="font-display text-4xl font-black tracking-tighter mt-4">You're live in the feed.</h1>
          <div className="mt-8 grad-border p-5 text-left relative overflow-hidden">
            {bubbleImageSrc(state.ad) && (
              <img src={bubbleImageSrc(state.ad)} alt={state.ad.title} className="rounded-xl mb-4 max-h-56 w-full object-cover" />
            )}
            <div className="chip text-bx-volt border-bx-volt/30 mb-3">Sponsored</div>
            <div className="font-display text-2xl font-black tracking-tighter">{state.ad.title}</div>
            {state.ad.subtitle && <p className="text-white/65 mt-2 text-sm">{state.ad.subtitle}</p>}
          </div>
          <div className="mt-8 flex items-center justify-center gap-3">
            <button data-testid="sponsor-success-feed" onClick={() => nav('/feed')} className="btn-primary px-6 py-3 rounded-full text-sm flex items-center gap-2">
              View in feed <ArrowRight size={14} weight="bold" />
            </button>
            <Link to="/sponsor" className="px-6 py-3 rounded-full glass-hi text-sm font-bold hover:bg-white/10 transition">Book another</Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default SponsorSuccess;
